import { getToken } from './auth';
import { swrCacheProvider } from './swrCache';

const VITE_API_URL = import.meta.env.VITE_API_URL;

if (!VITE_API_URL) {
  console.warn('VITE_API_URL not set. API calls will fail.');
}

/**
 * Enhanced fetch wrapper that attaches the JWT (if present)
 * to the Authorization header.
 *
 * All requests are directed to the configured Cloudflare Worker API.
 */
export async function apiRequest<T = unknown>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const token = getToken();

  const headers = new Headers(options.headers);
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(`${VITE_API_URL}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => ({}))) as {
      message?: string;
    };
    throw new Error(
      errorBody.message ||
        `API Error: ${response.status} ${response.statusText}`
    );
  }

  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }

  return {} as T;
}

export { swrCacheProvider };
